import styled, { css } from 'styled-components'

import { FlexContainer } from '../flexContainer'

type HeaderContainerProps = {
  backgroundColor?: string
  backdropFilter?: string
  open?: boolean
  shrinked?: boolean
  ref?: any
  id?: string
}

const transition = 'all 0.4s ease-in-out;'

export const FlexContainerHeader = styled(FlexContainer)<HeaderContainerProps>`
  padding: 0;
  width: 100%;
  max-width: 100vw;
  justify-content: center;
  position: fixed;
  top: 0;
  align-items: ${(props) => (props.open ? 'flex-start' : 'center')};
  z-index: 101;

  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor || `${theme.colors.black}72`};
  backdrop-filter: ${({ backdropFilter }) => backdropFilter || 'blur(10px)'};

  @media (max-width: 1180px) {
    padding: 0 16px !important;
  }
`
export const HeaderContainer = styled.div<HeaderContainerProps>`
  transition: ${transition};

  display: flex;
  align-items: ${(props) => (props.open ? 'flex-start' : 'center')};
  justify-content: space-between;

  width: 100%;
  height: 100%;
  max-width: 1170px;

  padding: 32px 0;

  ${(props) =>
    props.shrinked
      ? `
    margin-top: -0.5em;
    padding: 16px 0;

    .drawer-toogle {
      height: 36px;
      width: 36px;
    }
 `
      : ''};

  @media (max-width: 700px) {
    height: ${(props) => (props.open ? '100%' : '')};
  }

  .images {
    img {
      width: auto;
      object-fit: contain;
      height: 42px;
      transition: height 0.5s ease-in-out;
    }

    ${({ open, shrinked }) => {
      if (open && !shrinked) {
        return css`
          filter: blur(8px);
          height: 42px;
          z-index: -1;
          pointer-events: none;
        `
      }
      if (shrinked && open) {
        return css`
          filter: blur(8px);
          z-index: -1;
          pointer-events: none;
          img {
            height: 32px;
          }
        `
      }
      if (shrinked) {
        return css`
          img {
            height: 32px;
          }
        `
      }
      return ''
    }}

    transition: ${transition};

    :hover {
      cursor: pointer;
    }
    @media (max-height: 768px) {
      height: calc(42px * 0.8);
    }

    @media (max-width: 768px) {
      height: 32px;
    }

    @media (max-width: 375px) {
      height: 24px;
    }

    @media (max-width: 320px) {
      height: 16px;
    }
  }
`
